import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// AboutUsPage Component
const AboutUsPage = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  return (
    <div 
      className="min-h-screen font-karla flex flex-col"
      style={{
        backgroundImage: isMobile ? 'none' : 'url("/assets/abou_us/about_us_background.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Navbar Component */}
      <Navbar />
      
      {/* Main Content */}
      <div className="flex-1 overflow-y-auto">
        {/* AboutUsContent Section */}
        <section className="py-16 lg:py-12">
          <div className="max-w-7xl mx-auto px-4 lg:px-8">
            {/* Main Headline */}
            <div className="text-center mb-8">
              <h1 className="text-4xl lg:text-5xl font-bold mb-4">
                To Bring{' '}
                <span className="text-blue-600">Clarity</span>
                {' '}to a{' '}
                <span className="text-blue-600">Complex Market</span>
              </h1>
              
              {/* Sub-headline */}
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                The modern investor is drowning in information.
              </p>
            </div>

            {/* Main Text Body */}
            <div className="max-w-3xl mx-auto space-y-6 text-gray-800 leading-relaxed text-lg">
              {/* Paragraph 1 */}
              <p>
                Every day, you're hit with a firehose of news, conflicting expert opinions, social media hype, and endless data charts. It's more than just noise; it's a barrier that leads to analysis paralysis, missed opportunities, and decisions based on emotion rather than evidence. We knew there had to be a better way.
              </p>

              {/* Paragraph 2 */}
              <p>
                <strong>TrendVector was born from a simple idea:</strong> what if you could start your investment research with a clear, unbiased signal?
              </p>

              {/* Paragraph 3 */}
              <p>
                We're not here to give you hot stock tips or tell you what to buy. There are enough platforms doing that. Our mission is different. We are here to empower you—the independent, intelligent investor—by giving you your most valuable asset back: <strong className="text-blue-600">your time</strong>.
              </p>

              {/* Paragraph 4 */}
              <p>
                Our proprietary algorithm does the heavy lifting, applying disciplined, quantitative models to scan thousands of stocks. It operates without bias or emotion, identifying companies that meet strict criteria for both long-term value and short-term momentum.
              </p>

              {/* Paragraph 5 */}
              <p>
                This isn't a "black box." It's a powerful filter designed to hand you a manageable, pre-qualified list of opportunities. It's the starting point for your own research, allowing you to skip the tedious search and jump straight to the critical analysis where your insight truly matters.
              </p>

              {/* Closing Statements */}
              <div className="text-center pt-5">
                <p className="text-lg mb-1">You are the investor. You make the final call.</p>
                <p className="text-lg font-bold">We just provide the vector.</p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Footer Component */}
      <Footer />
    </div>
  );
};

export default AboutUsPage;
